import i18n from "../locales/i18n";

function getCookieLanguage() {
  try {
    const fromStorage = localStorage.getItem("i18nextLng");
    if (fromStorage) {
      return fromStorage.split("-")[0];
    }
  } catch (_) {
    // Storage may be unavailable in private mode.
  }

  const match = document.cookie.match(/(?:^|;\s*)i18nextLng=([^;]+)/);
  if (match) {
    return decodeURIComponent(match[1]).split("-")[0];
  }

  return "none";
}

function getDeviceType() {
  const ua = navigator.userAgent || "";

  if (/Mobi|Android.*Mobile|iPhone|iPod|Windows Phone|BlackBerry|Opera Mini/i.test(ua)) {
    return "phone";
  }

  if (/iPad|Tablet|Android(?!.*Mobile)/i.test(ua)) {
    return "tablet";
  }

  return "desktop";
}

function getVisitorType() {
  const ua = (navigator.userAgent || "").toLowerCase();
  const botPatterns = [
    "bot",
    "crawl",
    "spider",
    "slurp",
    "mediapartners",
    "googlebot",
    "bingbot",
    "yandex",
    "baiduspider",
    "duckduckbot",
    "facebookexternalhit",
    "telegrambot",
    "whatsapp",
    "lighthouse",
    "headless",
    "preview",
  ];

  if (botPatterns.some((pattern) => ua.includes(pattern))) {
    return "bot";
  }

  if (navigator.webdriver) {
    return "bot";
  }

  return "human";
}

async function fetchIpAndCountry() {
  try {
    const response = await fetch("https://ipwho.is/");
    const data = await response.json();

    if (data.success) {
      return {
        ip: data.ip || "unknown",
        country: data.country_code || "unknown",
      };
    }
  } catch (_) {
    // Fall back to IP-only lookup below.
  }

  try {
    const response = await fetch("https://api.ipify.org/?format=json");
    const data = await response.json();
    return {
      ip: data.ip || "unknown",
      country: "unknown",
    };
  } catch (_) {
    return {
      ip: "unknown",
      country: "unknown",
    };
  }
}

export async function getVisitorMeta() {
  const { ip, country } = await fetchIpAndCountry();

  return {
    i18nLang: (i18n.language || "en").split("-")[0],
    cookieLang: getCookieLanguage(),
    ip,
    country,
    device: getDeviceType(),
    visitor: getVisitorType(),
    userAgent: navigator.userAgent || "unknown",
  };
}

export function formatVisitorMeta(meta) {
  const summary = `Lang: i18n=${meta.i18nLang} cookie=${meta.cookieLang} | IP: ${meta.ip} | Country: ${meta.country} | Device: ${meta.device} | Visitor: ${meta.visitor}`;

  return `${summary}\n${meta.userAgent}`;
}
